import CreateChallenge from '@/src/components/challenges/CreateChallenge';
import React from 'react';

export const NewChallengePage: React.FC = () => {
  return <CreateChallenge />;
};
